import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import ArabicRegular from "../../../../../../../../src/assets/ArabicFont/IBMPlexSansArabic-Regular.ttf";
import ArabicBold from "../../../../../../../../src/assets/ArabicFont/IBMPlexSansArabic-Bold.ttf";
import PageLayout from "./PageLayout";

export default function AbsenteeismPdf({ contractDetails, data }) {
  Font.register({
    family: "Arabic",
    src: ArabicRegular,
  });
  Font.register({
    family: "ArabicBold",
    src: ArabicBold,
  });

  const styles = StyleSheet.create({
    table: {
      width: "100%",
      borderCollapse: "collapse",
      border: "1px solid black",
    },
    tableRow: {
      borderBottom: "1px solid black",
      flexDirection: "row",
    },
    tableCell: {
      padding: "5px",
      textAlign: "center",
      width: "100%",
      borderRight: "1px solid black",
    },
    header: {
      fontFamily: "Helvetica-Bold",
    },
  });

  console.log(data, "pdf data");
  return (
    <Document>
      <PageLayout pageNo={1} company={contractDetails?.visa_provider}>
        <View>
          <Text>
            Date: <Text>{data?.arrival_date}</Text>
          </Text>
        </View>
        <Text
          style={{
            fontFamily: "Helvetica-Bold",
            textDecoration: "underline",
            textAlign: "center",
            marginTop: 10,
            marginBottom: 5,
          }}
        >
          EMPLOYEE ABSENTEEISM POLICY
        </Text>
        <View>
          <Text style={{ marginBottom: 5 }}>
            Following shall be implemented to monitor employee absenteeism from
            date of Joining.
          </Text>
          <Text style={{ marginBottom: 5 }}>
            In case of any queries, please contact the{" "}
            <Text style={{ fontFamily: "Helvetica-Bold" }}>
              Project Coordinators / Site Coordinators.
            </Text>
          </Text>
        </View>
        {/* table */}
        <View style={styles.table}>
          <View style={styles.tableRow}>
            <Text style={[styles.tableCell, styles.header]}>
              No. of Days Absent without proper approval
            </Text>
            <Text style={[styles.tableCell, styles.header]}>Action</Text>
            <Text style={[styles.tableCell, styles.header]}>Penalty</Text>
            <Text style={[styles.tableCell, styles.header]}>Remarks</Text>
          </View>

          <View style={styles.tableRow}>
            <Text style={styles.tableCell}>1</Text>
            <Text style={styles.tableCell}>Warning letter to be issued</Text>
            <Text style={styles.tableCell}></Text>
            <Text style={styles.tableCell}></Text>
          </View>

          <View style={styles.tableRow}>
            <Text style={styles.tableCell}>2</Text>
            <Text style={styles.tableCell}>Warning letter to be issued</Text>
            <Text style={styles.tableCell}>1-day total salary</Text>
            <Text style={styles.tableCell}>
              1 day will be deducted in monthly salary
            </Text>
          </View>

          <View style={styles.tableRow}>
            <Text style={styles.tableCell}>3</Text>
            <Text style={styles.tableCell}>Warning letter to be issued</Text>
            <Text style={styles.tableCell}>1 + 1 = 2-days total salary</Text>
            <Text style={styles.tableCell}>
              2 days will be deducted in monthly salary
            </Text>
          </View>

          <View style={styles.tableRow}>
            <Text style={styles.tableCell}>4</Text>
            <Text style={styles.tableCell}>Warning letter to be issued</Text>
            <Text style={styles.tableCell}>
              1 + 1 + 1 = 3 days total salary + SAR 50
            </Text>
            <Text style={styles.tableCell}>
              3 days + SAR 50 fine will be deducted in monthly salary
            </Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={styles.tableCell}>More than 4 days</Text>
            <Text style={styles.tableCell}>Immediate Termination</Text>
            <Text style={styles.tableCell}></Text>
            <Text style={styles.tableCell}>As per company policy</Text>
          </View>
        </View>
        {/* sick leave */}
        <Text
          style={{
            fontFamily: "Helvetica-Bold",
            textDecoration: "underline",
            textAlign: "center",
            marginVertical: 10,
          }}
        >
          SICK LEAVE POLICY
        </Text>
        <View style={{ paddingLeft: 2 }}>
          <Text style={{ marginBottom: 2 }}>
            1. If an employee remains absent due to sickness, then he/she has to
            submit ALL of the following documents to the Project Coordinator:
          </Text>
          <Text style={{ marginBottom: 2, paddingLeft: 2 }}>
            a. Sick Leave from Clinic with Clinic Stamp
          </Text>
          <Text style={{ marginBottom: 2, paddingLeft: 2 }}>
            b. Doctor’s prescription with Doctor’s Stamp{" "}
          </Text>
          <Text style={{ marginBottom: 10, paddingLeft: 2 }}>
            c. Pharmacy invoice of medicines
          </Text>
        </View>
        <View style={{ marginBottom: 5, paddingLeft: 2 }}>
          <Text>
            2. If any of the above documents is not submitted, then that day
            (when he/she visited the Clinic) will be considered as{" "}
            <Text
              style={{
                fontFamily: "Helvetica-Bold",
                textDecoration: "underline",
              }}
            >
              ABSENT{" "}
            </Text>
            without approval and above absenteeism policy will imply.
          </Text>
        </View>
        {/* dynamic fields */}
        <Text style={{ marginVertical: 3 }}>
          I {data?.name}, {data?.candidate_id}, {data?.nationality_name}{" "}
          nationality bearing Passport No. {data?.passport_number}, hereby
          confirm that I have the read the above given policy and understood all
          terms and conditions.
        </Text>
        <Text style={{ marginBottom: 2 }}>
          I confirm and accept all the terms and conditions mentioned above.
        </Text>
        <Text style={{ marginBottom: 2 }}>
          I also confirm if I get terminated due to absenteeism policy, I will
          repay my company all the expenses incurred on me.
        </Text>

        {/* final */}
        <View style={{ flexDirection: "row", marginTop: 20 }}>
          <Text style={{ width: "100%" }}>Employee Name: {data?.name}</Text>
          <Text style={{ width: "100%" }}>Employee Signature:</Text>
        </View>
        <View style={{ flexDirection: "row", marginTop: 10 }}>
          <Text style={{ width: "100%" }}>
            Employee Position: {data?.job_position_name}
          </Text>
          <Text style={{ width: "100%" }}>Employee Thumb Impression:</Text>
        </View>
      </PageLayout>
    </Document>
  );
}
